import { Card } from 'antd';

import styles from './ErrorMessage.module.less';

import { Helmet } from '$HVUI';

/**
 * A base for all modern error components. New error components should use this.
 * @param {string} title page title as well as level-one header. Must be a string to work with the Helmet API.
 * @param {(node|string)} errorMessage error message content. Can be a React node or plain string.
 */

const ErrorBase = ({
    title = 'Something went wrong.',
    errorMessage,
    bordered = true
}) => {
    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <Card title={<h1>{title}</h1>} bordered={bordered}>
                {errorMessage || (
                    <div style={{ margin: '2em 0' }}>
                        <p data-testid="error-directions">
                            Please try again, or{' '}
                            {/* the second condition "provider-app" is used for storybook */}
                            {/provider\/app|provider-app/.test(
                                window.location.href
                            ) ? (
                                <>
                                    contact us at{' '}
                                    <a href="mailto:support@healthvana.com">
                                        support@healthvana.com
                                    </a>
                                </>
                            ) : (
                                <>
                                    visit{' '}
                                    <a href="https://healthvana.com/contact/">
                                        healthvana.com/contact/
                                    </a>
                                </>
                            )}
                        </p>
                    </div>
                )}
            </Card>
        </>
    );
};

export default ErrorBase;

export const Error404 = ({
    title = "We couldn't find that page.",
    errorMessage
}) => <ErrorBase title={title} errorMessage={errorMessage} />;

export const Error403 = ({
    title = "Sorry, you don't have permission to do that.",
    errorMessage = (
        <>
            <p>Your account cannot perform that action.</p>
        </>
    )
}) => <ErrorBase title={title} errorMessage={errorMessage} />;

/**
 * Error message style specific to Patient Portal.
 */

export const ErrorMessage = ({
    errorMessage = (
        <div className={styles['ErrorMessage']}>
            <span>
                We apologize. Something went wrong on our end. Please refresh
                the page or try again later.
            </span>
        </div>
    ),
    bordered = false
}) => <ErrorBase errorMessage={errorMessage} bordered={bordered} />;
